import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { useOnScreenEffect } from '@beef/utils';
import { useAnalyticsLinks } from "../hooks/useAnalyticsLinks";
import { AnalyticsPusherAppBanner } from "../utils/analytics";
export var withAnalyticsAppBanner = function withAnalyticsAppBanner(WrappedComponent) {
  return /*#__PURE__*/memo(function (props) {
    var ref = useOnScreenEffect(function () {
      AnalyticsPusherAppBanner.pushViewEvent();
    }, []);
    useAnalyticsLinks(ref, props.blockIndex);
    var handleClick = function handleClick(link, index) {
      var _props$onClick;
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, link);
      AnalyticsPusherAppBanner.pushClickEvent(link);
      AnalyticsPusherAppBanner.pushReachGoal(link, props.blockIndex, index);
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref
    }, props, {
      onClick: handleClick,
      "data-t-id": "src-hocs"
    }));
  });
};